// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance = null;

  function initSwiper() {
    if (window.innerWidth < 870 && !swiperInstance) {
      swiperInstance = new Swiper(".tabs__buttons.swiper", {
        slidesPerView: "auto",
        spaceBetween: 8,
        watchOverflow: true,
        freeMode: true,
        freeModeSticky: true,
      });
    } else if (window.innerWidth >= 870 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  const sliderSwiper = new Swiper(".slider-wrapper.swiper", {
    slidesPerView: 1,
    centeredSlides: false,
    pagination: {
      el: ".slider .swiper-pagination",
      clickable: true,
      type: "bullets",
    },
    breakpoints: {
      768: {
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: false,
      },
    },
    on: {
      slideChange: function () {
        const realIndex = this.realIndex;
        activateSlide(slides[realIndex]);
      },
      progress: function () {
        // Update active class on bullets while dragging
        const progress = this.progress; // 0 - 1
        const bullets = this.pagination.el.querySelectorAll(
          ".swiper-pagination-bullet",
        );
        bullets.forEach((bullet, index) => {
          bullet.classList.remove("swiper-pagination-bullet-active");
        });

        // Calculate closest bullet based on progress
        const activeIndex = Math.round(progress * (this.slides.length - 1));
        if (bullets[activeIndex]) {
          bullets[activeIndex].classList.add("swiper-pagination-bullet-active");
        }
      },
    },
  });

  initSwiper();
  window.addEventListener("resize", initSwiper);
});
